import React from "react";
import { MRT_ColumnDef } from "material-react-table";
import { ReminderCollector } from "api";

export const COLUMNS: MRT_ColumnDef<ReminderCollector>[] = [
  {
    accessorKey: "siteName",
    header: "Site",
    size: 100,
    maxSize: 100,
    Cell: ({ cell }) => cell.getValue<string>() ?? "-",
    muiTableBodyCellProps: {
      sx: { whiteSpace: "normal", wordBreak: "break-word" },
    },
  },
  {
    accessorKey: "accountNumber",
    header: "Account",
    size: 100,
    maxSize: 100,
    Cell: ({ cell }) => cell.getValue<string>() ?? "-",
    muiTableBodyCellProps: {
      sx: { whiteSpace: "normal", wordBreak: "break-word" },
    },
  },
  {
    accessorKey: "meterNumber",
    header: "Meter",
    size: 100,
    maxSize: 100,
    Cell: ({ cell }) => cell.getValue<string>() ?? "-",
    muiTableBodyCellProps: {
      sx: { whiteSpace: "normal", wordBreak: "break-word" },
    },
  },
  {
    accessorKey: "utilityTypeName",
    header: "Utility Type",
    size: 100,
    maxSize: 100,
    Cell: ({ cell }) => cell.getValue<string>() ?? "-",
    muiTableBodyCellProps: {
      sx: { whiteSpace: "normal", wordBreak: "break-word" },
    },
  },
  {
    accessorKey: "missingMonths",
    header: "Missing Months",
    muiTableBodyCellProps: {
      sx: {
        color: "error.main",
        fontWeight: 500,
        whiteSpace: "normal",
        wordBreak: "break-word",
      },
    },
    Cell: ({ cell, row }) => {
      const raw = cell.getValue<string>();
      const partialMonths: string[] = row.original.partialMonths ?? [];
      if (!raw && partialMonths.length === 0) return "-";
      if (partialMonths.length === 0) return raw || "-";

      const missingEntries = raw ? raw.split(", ") : [];
      const allEntries = [
        ...missingEntries.map((label) => ({ label, isPartial: false })),
        ...partialMonths.map((label) => ({ label, isPartial: true })),
      ];

      return (
        <>
          {allEntries.map(({ label, isPartial }, i) => (
            <React.Fragment key={label}>
              {i > 0 && ", "}
              {label}
              {isPartial && " (partial)"}
            </React.Fragment>
          ))}
        </>
      );
    },
  },
];
